import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class Training extends React.Component {
    render() {
      return (

      <div id='Training' style={{backgroundColor: '#08081c'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Training</h2>
            <div> 


     <div className="generic-column" style={{ width: '100%' }}>
    <h3>Training & Knowledge Transfer</h3>
    <p>
        We provide bespoke, high-level technical training for engineering teams 
        globally, ensuring your workforce is fully equipped to maintain and 
        optimise modern industrial systems.
    </p>

    <p>
        Our training programmes are tailored to your specific hardware and software environment:
    </p>

    <div className="usp-list">
        <div className="usp-item">
            <strong>Robotics & Automation</strong>
            <span>
                Specialising in the programming and deployment of industrial 
                robotics, we provide hands-on training for system integration, 
                motion control, and safety-critical automation protocols.
            </span>
        </div>


        <div className="usp-item">
            <strong>Global On-Site Delivery</strong>
            <span>
                Our expertise is available anywhere in the world. We offer 
                on-site intensive training sessions designed to bridge the gap 
                between theoretical knowledge and real-world industrial application.
            </span>
        </div>


    </div>
</div>


           </div>
        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default Training;

